import {inject, type InjectionKey, onBeforeMount, onUnmounted, provide} from 'vue'
import mitt, {type Emitter,type  Handler} from 'mitt'

export interface SearchPageReload {
  reloadFirstPage(): void
}

type SearchPageEvents = { reloadFirstPage: void }
type SearchPageEmitter = Emitter<SearchPageEvents>

const emitterKey = Symbol('search-page-reload') as InjectionKey<SearchPageEmitter>

export function provideSearchPageReload(): SearchPageReload {
  const emitter = mitt<SearchPageEvents>()
  provide(emitterKey, emitter)
  return {
    reloadFirstPage: () => emitter.emit('reloadFirstPage')
  }
}

export function useSearchPageReload<E extends keyof SearchPageEvents>(event: E, handler: Handler<SearchPageEvents[E]>) {
  const emitter = inject(emitterKey)
  if (emitter) {
    onBeforeMount(() => emitter.on(event, handler))
    onUnmounted(() => emitter.off(event, handler))
  } else {
    console.warn("Missing provideSearchPageReload() in parent component")
  }
}
